import alarmCardGql from "@/http/requests/cbs/alarm_gql";

export default {
	fetchAlarms({ commit }, payload) {
		return new Promise((resolve, reject) => {
			alarmCardGql
				.getAlarmsgs(payload)
				.then(response => {
					commit("SET_ALARMS", response.alarms);
					commit("SET_TOTAL_ALARMS", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	fetchAlarmsSetting({ commit }, payload) {
		return new Promise((resolve, reject) => {
			alarmCardGql
				.getAlarmsSetting(payload)
				.then(response => {
					commit("SET_ALARMS_SETTING", response.alarmsSetting);
					commit("SET_TOTAL_ALARMS_SETTING", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	createAlarmSetting({ commit }, payload) {
		return new Promise((resolve, reject) => {
			alarmCardGql
				.createAlarm(payload)
				.then(response => {
					commit("ADD_ALARM_SETTING", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	updateAlarmSetting({ commit }, payload) {
		return new Promise((resolve, reject) => {
			alarmCardGql
				.updateAlarm(payload)
				.then(response => {
					commit("UPDATE_ALARM_SETTING", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	deleteAlarmSetting({ commit }, payload) {
		return new Promise((resolve, reject) => {
			alarmCardGql
				.deleteAlarm(payload)
				.then(response => {
					commit("DELETE_ALARM_SETTING", payload.id);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	receivedAlarmsg({ commit }, payload) {
		return new Promise((resolve, reject) => {
			alarmCardGql
				.receivedAlarmsg(payload)
				.then(response => {
					commit("SET_IS_RECEIVED_ALARMSG", payload.id);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	getAlarmsgItem({ commit }, payload) {
		return new Promise((resolve, reject) => {
			alarmCardGql
				.getAlarmsgItem(payload)
				.then(response => {
					commit("UPDATE_ALARM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
